export default "__VITE_ASSET__0vhHL1v5__"